export default "__VITE_ASSET__42df637e__"